export default "__VITE_ASSET__D1GmzyFR__"